import type { SsrSuccessBreakdown } from '@atlaskit/react-ufo/ssr';
import { ssrFailureReasons } from './ssrFailureReasons.tsx';

/**
 * Canonical SSR-success predicate shared by the SSR renderer
 * (`entry-ssr/.../services/success`) and the client UFO config
 * (`ufo-interaction-metrics-init/.../jira-ssr-config`). Both sides import this
 * function so the success formula has exactly one runtime definition.
 *
 * Every boolean flag on {@link SsrSuccessBreakdown} is a failure condition, so
 * SSR is successful only when none of the {@link ssrFailureReasons} flags is
 * `true`. That list is the single source of truth and is kept exhaustive against
 * the type at build time.
 *
 * The non-boolean evidence fields (`failedResources`, `failedResourceCount`,
 * `failedRouteResources`, `failedRouteResourceCount`) are intentionally not
 * consulted here.
 */
export const computeSsrSuccess = (breakdown: SsrSuccessBreakdown): boolean =>
	!ssrFailureReasons.some((reason) => breakdown[reason]);
